import { getOptions } from './getOptions';
import { getUrl } from './getUrl';
import { DataProviderPayload, DataProviderResource, FetchType } from './types';

export const createHTTPRequest = (type: FetchType, resource: DataProviderResource, payload: DataProviderPayload) => ({
  url: getUrl(type, resource, payload),
  options: getOptions(type, payload),
});
